<template>
  <div>
    <br>
    <v-portlet class="box green">
      <div slot="title" class="portlet-title">
        <div slot="caption" class="caption">
          <i class="icon-bubble"></i>
          Deal Alerts
        </div>
        <div slot="actions" class="actions">
        </div>
      </div>

      <div slot="body">
        <data-tables :data="data">
          <el-table-column v-for="title in titles"
                           :prop="title.prop"
                           :label="title.label"
                           :key="title.prop"
                           sortable="true">
          </el-table-column>
          <el-table-column label="Actions" min-width="100px">
            <template slot-scope="scope">
              <button
                @click="deleteAlert(scope.row)"
                type="button" class="btn red btn-sm"><i class="fa fa-close"></i>
                DELETE
              </button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </v-portlet>
  </div>
</template>
<script>
  /* ============
   * CLO Deal Alert Component
   * ============
   *
   */
  import VDatatables from '@/app/components/datatables/Datatable'
  import VPortlet from '@/app/components/Portlet'
  import InvalidDealProxy from '@/app/proxies/InvalidDealProxy'

  const titles = [
    {
      prop: 'dealId',
      label: 'Deal ID'
    }, {
      prop: 'dealTitle',
      label: 'Deal Title'
    }, {
      prop: 'type',
      label: 'Type'
    },
    {
      prop: 'error',
      label: 'Error'
    }
  ]

  export default {
    components: {
      VDatatables,
      VPortlet
    },
    data () {
      return {
        data: [],
        titles: titles,
        proxy: null
      }
    },
    computed: {
      selectedDeal () {
        return this.$store.state.app.selectedDeal
      }
    },
    methods: {
      getData () {
        this.proxy.submit('get', this.proxy.endpoint, {
          type: this.proxy.type
        })
          .then(res => {
            this.data = res.data.map(item => {
              const itemData = JSON.parse(item.data)
              return {
                dealId: itemData.id,
                dealTitle: itemData.title,
                type: item.type,
                error: JSON.stringify(itemData.errors)
              }
            })
          })
          .catch(err => {
            this.$notify.error({
              title: 'Error',
              message: 'Error occured.'
            })
            console.log(err)
          })
      },
      deleteAlert (row) {
        this.proxy.destroy(row.dealId + '-' + row.type)
          .then(res => {
            if (res.status === 204) {
              this.$notify.success({
                title: 'Success',
                message: 'Item successfully deleted.'
              })
              this.getData()
            }
          })
          .catch(err => {
            this.$notify.error({
              title: 'Error',
              message: 'Error occured.'
            })
            console.log(err)
          })
      }
    },
    created () {
      this.proxy = new InvalidDealProxy()
      this.getData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Alerts/DealAlert.vue